module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-7.0d302d2b.svg";